/* eslint-disable @typescript-eslint/no-explicit-any */
import Qs from 'qs'
import service from '@/services/service'
import { APIReport } from '@/models/api/report.model'
import { FieldName } from '@/interfaces/field-name.interface'

const resource = {
    main: 'services',
    module: 'reports'
}
export class ReportsServices {
    public static getReports () {
        return service.get(`${resource.main}/${resource.module}`)
    }

    public static getReportsPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getReportFavoritesPaginate (params: object) {
        return service.get(`${resource.main}/${resource.module}/favorite/paginate`, {
            params,
            paramsSerializer: (params) => {
                return Qs.stringify(params, { arrayFormat: 'indices' })
            }
        })
    }

    public static getReportsById (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}`)
    }

    public static getReportShares (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}/get-shares`)
    }

    public static createReports (params: APIReport) {
        return service.post(`${resource.main}/${resource.module}`, params)
    }

    public static createReportShares (params: { reportId: number; users: number[] }) {
        return service.post(`${resource.main}/${resource.module}/share`, params)
    }

    public static addFavorite (params: { reportId: number; userId: number }) {
        return service.post(`${resource.main}/${resource.module}/add-favorite`, params)
    }

    public static addUserFilter (params: {reportId: number; userId: number; createReportUserFilter: string; reportUserFilterData: string}) {
        return service.post(`${resource.main}/${resource.module}/add-user-filter`, params)
    }

    public static getUserFilter (params: {reportId: number; userId: number}) {
        return service.post(`${resource.main}/${resource.module}/get-user-filter`, params)
    }

    public static addRoleToReport (reportId: number, roles: number[]) {
        return service.post(`${resource.main}/${resource.module}/add-roles`, { reportId, roles })
    }

    public static editReports (params: APIReport) {
        return service.put(`${resource.main}/${resource.module}/${params.reportId}`, params)
    }

    public static removeRoleToReport (reportId: number, roles: number[]) {
        return service.put(`${resource.main}/${resource.module}/delete-roles`, { reportId, roles })
    }

    public static cloneReports (id: number) {
        return service.put(`${resource.main}/${resource.module}/clone/${id}`)
    }

    public static deleteReports (id: number) {
        return service.delete(`${resource.main}/${resource.module}/${id}`)
    }

    public static deleteFavorites (id: number) {
        return service.delete(`${resource.main}/${resource.module}/delete-favorite/${id}`)
    }

    public static deleteUserFilter (id: number) {
        return service.delete(`${resource.main}/${resource.module}/delete-user-filter/${id}`)
    }

    public static getReportFilters (id: number) {
        return service.get(`${resource.main}/${resource.module}/${id}/get-filters`)
    }

    public static viewReport (id: number, reportFilters: FieldName[]) {
        return service.put(`${resource.main}/${resource.module}/${id}/view`, { reportFilters })
    }

    public static exportReportCsv (id: number, reportFilters: FieldName[]) {
        return service.put(`${resource.main}/${resource.module}/${id}/export`, { reportFilters })
    }
}
